import {
  IntegrityMonitorMode,
  IntegrityMonitorRealTimeSection,
  IntegrityMonitorRuleProcessingModeOption,
} from '@nirvana/shared/dtos/types/policies/common';
import { SearchableKeyword } from '../../../../../../ui/gzSearchableAccordionsPanel/types';
import { translateFn } from '../../../../../../utils/translator.helper';
import { IntegrityMonitorRealTimeSearchableKeywords } from './integrity-monitor.types';

export const INTEGRITY_MONITOR_REAL_TIME_DEFAULT_VALUE: IntegrityMonitorRealTimeSection = {
  enabled: false,
  ruleProcessingMode: IntegrityMonitorRuleProcessingModeOption.NORMAL,
  mode: IntegrityMonitorMode.RULE_SETS,
  ruleSetIds: [],
};

// searchable keywords
export function getIntegrityMonitorRealTimeSearchableKeywords(): {
  [type in IntegrityMonitorRealTimeSearchableKeywords]: SearchableKeyword;
} {
  return {
    [IntegrityMonitorRealTimeSearchableKeywords.IntegrityMonitor]: {
      translatedLabel: translateFn('Integrity Monitoring'),
      label: 'Integrity Monitoring',
    },
    [IntegrityMonitorRealTimeSearchableKeywords.IntegrityProcessingMode]: {
      translatedLabel: translateFn('Rules processing mode'),
      label: 'Rules processing mode',
    },
    [IntegrityMonitorRealTimeSearchableKeywords.IntegrityRealTime]: {
      translatedLabel: translateFn('Real-time monitoring'),
      label: 'Real-time monitoring',
    },
  };
}
